<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>In memory of my father, Peter Jones. I’m glad we got to discuss this one.</span></p>
<p class="P_Norm-Center"><span> </span></p>
<p class="P_Norm-Center"><span>Dear Reader, if you get the feeling that someone is reading over your shoulder, but there’s no one there? Don’t panic—it’s just my dad. He’s checking my grammar. ;-)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?76ac33d1